// extracted by mini-css-extract-plugin
export default {"wrapper":"successpage_wrapper__AYplM"};